import React from "react";
import GroupProjectsTab from "../../Components/GroupProjectsTab/GroupProjectsTab";
import PageInfoModal from "../../Components/PageInfoModal/PageInfoModal";

const PROJECTS_INFO_ITEMS = [
  { icon: 'collection', text: 'Sol tərəfdəki qrup siyahısından bir qrup seçin.' },
  { icon: 'journal-plus', text: 'Qrup seçdikdən sonra həmin qrupa layihə tapşırığı əlavə edə bilərsiniz.' },
  { icon: 'eye', text: 'Mövcud layihə tapşırıqlarının detallarına baxa bilərsiniz.' },
  { icon: 'file-earmark-check', text: 'Tələbələrin göndərdiyi layihə təslimatlarını yoxlaya bilərsiniz.' },
  { icon: 'pencil', text: 'Mövcud layihə tapşırıqlarını redaktə edə bilərsiniz.' },
];

const ProjectsPage = () => {
  return (
    <div style={{
      height: "100%", display: "flex", flexDirection: "column",
      overflow: "hidden", backgroundColor: "#fcfcfc",
      padding: "12px 16px", gap: 12,
    }}>

      {/* Page header */}
      <div style={{
        background: "var(--color-surface)",
        border: "1px solid var(--color-border)",
        borderRadius: 12,
        padding: "16px 24px",
        flexShrink: 0,
        boxShadow: "var(--shadow-xs)",
        display: "flex",
        alignItems: "center",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, width: "100%" }}>
          <PageInfoModal title="Layihələr" items={PROJECTS_INFO_ITEMS} />
          <div style={{
            width: 42, height: 42,
            background: "var(--color-primary)",
            borderRadius: 10,
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 2px 8px rgba(37,99,235,0.2)",
            flexShrink: 0,
          }}>
            <i className="bi bi-journal-code" style={{ color: "#fff", fontSize: 20 }}></i>
          </div>
          <div style={{ flex: 1 }}>
            <h4 style={{
              margin: 0, fontWeight: 700, fontSize: 18,
              color: "var(--color-text)",
              letterSpacing: "-0.2px",
            }}>
              Layihələr
            </h4>
            <p style={{ margin: 0, fontSize: 12, color: "var(--color-text-secondary)" }}>
              Qruplara layihə tapşırıqlarını idarə edin
            </p>
          </div>
        </div>
      </div>

      <div className="component-chg border-top rounded" style={{
        flex: 1, overflow: "hidden", minHeight: 0,
        display: "flex", flexDirection: "column",
      }}>
        <GroupProjectsTab />
      </div>
    </div>
  );
};

export default ProjectsPage;
